import React from 'react';
import { withStyles, makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import firebase from '../services/firebase';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import FormGroup from '@material-ui/core/FormGroup';
import EditIcon from '@material-ui/icons/Edit';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import DeleteIcon from '@material-ui/icons/Delete';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { jsPDF } from "jspdf";
import  amirifont from '../assets/Amiri-Regular.ttf';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import alroshanLogo from '../assets/logo.png';
import GetAppIcon from '@material-ui/icons/GetApp';

import {
    BrowserRouter as Router,
    Switch, Route,Link,useParams
} from "react-router-dom";

import swal from 'sweetalert';


const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: '#37474f',
        color: theme.palette.common.white,
    },
    body: {
        fontSize: 14,
    },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

function createData(eCount,eDate,eId,eName,oName,hallName,eStatus,eLicenseUrl) {
    return { eCount,eDate,eId,eName,oName,hallName,eStatus,eLicenseUrl };
}

function createBlockData(blockCount,blockId,blockPrice,blockLabelName,participantId,participantName,participantStatus) {

    return {blockCount,blockId,blockPrice,blockLabelName,participantId,participantName,participantStatus}
}

function createEventLeads(leadCount,cId,cName,cPhone,sId,sName) {

    return{leadCount,cId,cName,cPhone,sId,sName}
}

function createEventImages(imageCount,imageId,imageName,imageUrl) {

    return {imageCount,imageId,imageName,imageUrl}
}

function createAddonService(count,sId,sType,sPrice) {

    return {count,sId,sType,sPrice}
}

function createEventLayoutImages(imageCount,imageId,imageName,imageUrl) {

    return{imageCount,imageId,imageName,imageUrl}
}


var rows = [];
var eventId = "";
var bookingStatus = "";

const db = firebase.firestore();
const storage = firebase.storage();





const useStyles = makeStyles((theme: Theme) =>
    createStyles({


        table: {
            minWidth: 700,
        },
        link:{

            textDecoration:'none',
            color:theme.palette.text.primary

        },
        root: {
            '& > *': {
                margin: theme.spacing(1),
            },
            float:'right',
            marginTop:'5px',
            marginBottom:'5px',


        },
        input: {
            display: 'none',
        },
        root4: {
            position:'fixed',
            display: 'flex',
            justifyContent:'center',
            marginTop:'60px',
            marginLeft:'40%',

        },
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        },


    }),
);

function getBookingDate(beId,bCount,callback) {


    db.collection("booking").doc(beId).collection("booking_dates").get().then(function (querySnapshot) {

        var callBackString = {};
        querySnapshot.forEach(function (doc) {


            var bDate = doc.data();
            callBackString.bookingDate = bDate.booked_date;

        });
        callback(callBackString);



    });


}



export default function EventsDetails() {
    const classes = useStyles();

    eventId = useParams().id;
    bookingStatus = useParams().status;

    const [state,setState] = React.useState();
    const [showLoading,setShowLoading] = React.useState(false);
    var [eventData,setEventData] = React.useState([]);
    var [eventBlocks,setEventBlocks] = React.useState([]);
    var [eventLeads,setEventLeads] = React.useState([]);
    const [eventAddonService,setEventAddonService] = React.useState([]);

    const [eventImages,setEventImages] = React.useState([]);
    const [eventLayoutImages,setEventLayoutImage] = React.useState([]);


    const [reciptBtn,setReciptBtn] = React.useState(false);
    const [contractBtn,setcontractBtn] = React.useState(false);

    const [confirm,setConfirm] = React.useState(false);

    const [eData,setEdata] = React.useState({

        eventName:"",
        eventDescription:"",
    });

    const [scegaLicense,setScegaLicense] = React.useState({

        oldfile:"",
        scegaLicenseFile:""
    });

    const [eBlockData,seteBlockData] = React.useState({

        eBlockLabel:"",
        eBlockPrice:""
    });

    const [error1,setError1] = React.useState({
        eventName:false,
        eventDescription:false
    });

    const [eImgData,setEImgdata] = React.useState({

        eventImageId:"",
        eventImageData:"",
        eventOldImage:""
    });

    const [eLayoutImgData,seteLayoutImgData] = React.useState({


        eventLayoutImage:""

    });

    const [eBulkFile,seteBulkFile] = React.useState({


        eBulkFile:""

    });

    const [eventDates,setEventDates] = React.useState("");
    const [organizerData,setOrganizerData] = React.useState({

        oName:"",
        oCompanyName:"",
        oMobileNumber:"",

    });





    const selectedLanguage = localStorage.getItem("lang") || 'en';



    React.useState(()=>{




    });


    const handleChangeBulkBlock = (props) => (e) => {

        console.log(e.target.files[0].name.split(".")[1]);

        if(props==="eventBulkBlock"){


            if(e.target.files[0].name.split(".")[1]==="csv"){

                seteBulkFile({eBulkFile:e.target.files[0]})

            }else {

                swal("Select CSV File");
                seteBulkFile({eBulkFile:""})
            }


        }


      /*  if(props==="eventBulkBlock"){


            if(e.target.files[0].type==="text/csv"){

                seteBulkFile({eBulkFile:e.target.files[0]})

            }else {

                swal("Select CSV File");
                seteBulkFile({eBulkFile:""})
            }


        }*/

    };


    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = React.useState(false);
    const handleOpen1 = (props) =>() => {
        setOpen1(true);

        const eData = props.split("|");
        const oldImageId = eData[0];
        const oldImage = eData[1];

        setEImgdata({eventImageId:oldImageId,eventImageData:eImgData.eventImageData,eventOldImage:oldImage})

    };

    const handleClose1 = () => {
        setOpen1(false);
    };


    const [open2, setOpen2] = React.useState(false);
    const handleOpen2 = (props) =>() => {

        setOpen2(true)
    };

    const handleClose2 = (props) =>() => {

        setOpen2(false)
    };


    const [open3, setOpen3] = React.useState(false);
    const handleOpen3 = (props) =>() => {

        setOpen3(true)
    };

    const handleClose3 = (props) =>() => {

        setOpen3(false)
    };



    const [open4, setOpen4] = React.useState(false);
    const handleOpen4 = (props) =>() => {

        setOpen4(true)
    };

    const handleClose4 = (props) =>() => {

        setOpen4(false)
    };

    const [open5, setOpen5] = React.useState(false);
    const handleOpen5 = (props) =>() => {

        setOpen5(true)
    };

    const handleClose5 = (props) =>() => {

        setOpen5(false)
    };


    const handleEventImageChange = (props)=>(e) => {

        if(props==="eventImage"){

            setEImgdata({eventImageId:eImgData.eventImageId,eventImageData:e.target.files[0],eventOldImage:eImgData.eventOldImage})

        }


    };

    const handleScegaLicense = (props) => (e) => {

        if(props==="scegaLicenseFile"){

            setScegaLicense({oldfile:scegaLicense.oldfile,scegaLicenseFile:e.target.files[0]})
        }

    };

    const handleBlockDataChange = (props)=>(e) => {

        if(props==="eBlockLabel"){

            seteBlockData({eBlockLabel:e.target.value,eBlockPrice:eBlockData.eBlockPrice})

        }
        if(props==="eBlockPrice"){

            seteBlockData({eBlockLabel:eBlockData.eBlockLabel,eBlockPrice:e.target.value})

        }



    };

    const handleChangeLayoutImage = (props) => (e) => {

        if(props==="eventLayoutImage"){

            seteLayoutImgData({eventLayoutImage:e.target.files[0]})

        }

    };

    const deleteLayoutImage = (props) =>() => {


        const deleteData = props.split("|");
        const layoutImageId = deleteData[0]
        const layoutImageFileName = deleteData[1]

        // alert(layoutImageFileName);

        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this layout image!",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {

                    setShowLoading(true);
                    var storageRef0 = firebase.storage().ref();
                    storageRef0.child('layoutImages/'+layoutImageFileName).delete().then(function() {

                        db.collection("booking").doc(eventId).collection("layout_image").doc(layoutImageId).delete().then(function() {

                            setShowLoading(false);
                            swal({
                                title: "Successfully deleted",
                                text: "Successfully deleted",
                                icon: "success",
                                button: "OK!",
                            }).then((value) => {


                                window.location.reload();

                            });


                        }).catch(function(error) {




                        });


                    }).catch(function(error) {



                    });






                } else {
                    swal("Your layout image is safe!");
                }
            });









    };


    const addBulkBlock = (e) => {

        e.preventDefault();


        if(eBulkFile.eBulkFile===""){
            swal("Select CSV file");

        }else {

            setShowLoading(true);
            var oFile = eBulkFile.eBulkFile;
            var reader = new FileReader();
            reader.onload = function () {

                console.log(reader.result);//S12,600

                var lines = reader.result.split("\n");
                while( typeof lines[0] !== "undefined" ){
                    var line = lines.shift();
                    var split = line.split(',');

                    if(typeof split[1] !== "undefined"){


                        if(split[0]==="" || split[1]===""){

                        }else {


                            if(split[0]=== "Booth Name" && split[1] === "Price(SR)"){

                            }else {


                                if(split[1].match(/^[0-9]+$/) !==null){

                                    console.log(split[0]);
                                    console.log(split[1]);


                                    var docRef = db.collection("booking").doc(eventId).collection("event_blocks").doc();

                                    docRef.set({

                                        b_id:docRef.id,
                                        b_label_price:split[1],
                                        b_lable_name:split[0],
                                        b_participent_id:"",
                                        b_participent_name:"",
                                        b_participent_note:"",
                                        b_participient_status:"",
                                        o_status:"",
                                        timeStamp:""

                                    }).then(function() {
                                        console.log("Document successfully written!");
                                    }).catch(function(error) {
                                        console.error("Error writing document: ", error);
                                    });






                                }



                            }




                        }




                    }
                }




            };

            reader.readAsBinaryString(oFile);

            setTimeout(()=>{

                setShowLoading(false);

                swal({
                    title: "Successfully added",
                    text: "Successfully added",
                    icon: "success",
                    button: "OK!",
                }).then((value) => {



                    window.location.reload();

                });




            },2000)



        }


    };

    const addLayoutImage = (e) => {

        e.preventDefault();

        if(eLayoutImgData.eventLayoutImage.length <=0){

            swal("select layoutImage");

        }else {

            // alert(eLayoutImgData.eventLayoutImage.name)

            setShowLoading(true);

            var bannerImage  = eLayoutImgData.eventLayoutImage;
            var bannerFileName = (+new Date()) + '-' + bannerImage.name;
            var storageRef = firebase.storage().ref();
            var uploadTask = storageRef.child('layoutImages/'+bannerFileName+'').put(bannerImage);
            uploadTask.on('state_changed', function(snapshot){

                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
                switch (snapshot.state) {
                    case firebase.storage.TaskState.PAUSED: // or 'paused'
                        console.log('Upload is paused');
                        break;
                    case firebase.storage.TaskState.RUNNING: // or 'running'
                        console.log('Upload is running');
                        break;
                }
            }, function(error) {

            }, function() {

                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

                    db.collection("booking").doc(eventId).collection("layout_image").add({
                        l_image_filename: bannerFileName,
                        l_id: "",
                        l_image_url: downloadURL.toString(),

                    }).then(function(docRef) {

                        var docId = docRef.id;

                        db.collection("booking").doc(eventId).collection("layout_image").doc(docId).update({
                            l_id: docId
                        }).then(function() {
                            console.log("Document successfully updated!");

                            setShowLoading(false);
                            swal({
                                title: "Successfully added",
                                text: "Successfully added",
                                icon: "success",
                                button: "OK!",
                            }).then((value) => {


                                window.location.reload();

                            });




                        }).catch(function(error) {
                            // The document probably doesn't exist.
                            console.error("Error updating document: ", error);



                        });



                    });


                });
            });




        }




    }

    const addEventBlocks = (e) => {

        e.preventDefault();

        if(eBlockData.eBlockLabel ===""){

            swal("Booth Label Cannot Empty");


        }else if(eBlockData.eBlockPrice===""){

            swal("Price Cannot Empty");

        }else {

            setShowLoading(true);
            db.collection("booking").doc(eventId).collection("event_blocks").add({
                b_id: "",
                b_label_price: eBlockData.eBlockPrice,
                b_lable_name: eBlockData.eBlockLabel,
                b_participent_id:"",
                b_participent_name:"",
                b_participent_note:"",
                b_participient_status:"",
                o_status:"",
                timeStamp:"",

            }).then(function(docRef) {

                var docId = docRef.id;

                db.collection("booking").doc(eventId).collection("event_blocks").doc(docId).update({
                    b_id: docId
                }).then(function() {


                    setShowLoading(false);
                    swal({
                        title: "Successfully added",
                        text: "Successfully added",
                        icon: "success",
                        button: "OK!",
                    }).then((value) => {


                        window.location.reload();

                    });




                }).catch(function(error) {
                    // The document probably doesn't exist.
                    console.error("Error updating document: ", error);



                });



            });

        }



    };

    const addScegaLicense = (e) => {

        e.preventDefault();

        if(scegaLicense.scegaLicenseFile.length <=0){

            swal("select SCEGA License FILE");
        }else {


            if(scegaLicense.oldfile===""){

                setShowLoading(true);
                var bannerImage  = scegaLicense.scegaLicenseFile;
                var bannerFileName = (+new Date()) + '-' + bannerImage.name;
                var storageRef = firebase.storage().ref();
                var uploadTask = storageRef.child('eventLicenses/'+bannerFileName+'').put(bannerImage);
                uploadTask.on('state_changed', function(snapshot){

                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                            console.log('Upload is paused');
                            break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                            console.log('Upload is running');
                            break;
                    }
                }, function(error) {

                }, function() {

                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

                        db.collection("booking").doc(eventId).update({
                            b_e_licenseUrl: downloadURL.toString(),
                            b_e_licensedoc: bannerFileName
                        }).then(function() {
                            console.log("Document successfully updated!");

                            setShowLoading(false);
                            swal({
                                title: "Successfully uploaded",
                                text: "Successfully uploaded",
                                icon: "success",
                                button: "OK!",
                            }).then((value) => {


                                window.location.reload();

                            });




                        }).catch(function(error) {
                            // The document probably doesn't exist.
                            console.error("Error updating document: ", error);



                        });


                    });
                });



            }else {

                //alert(scegaLicense.scegaLicenseFile.name+" "+scegaLicense.oldfile);
                setShowLoading(true);
                var storageRef0 = firebase.storage().ref();
                storageRef0.child('eventLicenses/'+scegaLicense.oldfile).delete().then(function () {

                    var bannerImage  = scegaLicense.scegaLicenseFile;
                    var bannerFileName = (+new Date()) + '-' + bannerImage.name;
                    var storageRef = firebase.storage().ref();
                    var uploadTask = storageRef.child('eventLicenses/'+bannerFileName+'').put(bannerImage);
                    uploadTask.on('state_changed', function(snapshot){

                        var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        console.log('Upload is ' + progress + '% done');
                        switch (snapshot.state) {
                            case firebase.storage.TaskState.PAUSED: // or 'paused'
                                console.log('Upload is paused');
                                break;
                            case firebase.storage.TaskState.RUNNING: // or 'running'
                                console.log('Upload is running');
                                break;
                        }
                    }, function(error) {

                    }, function() {

                        uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

                            db.collection("booking").doc(eventId).update({
                                b_e_licenseUrl: downloadURL.toString(),
                                b_e_licensedoc: bannerFileName
                            }).then(function() {
                                console.log("Document successfully updated!");

                                setShowLoading(false);
                                swal({
                                    title: "Successfully uploaded",
                                    text: "Successfully uploaded",
                                    icon: "success",
                                    button: "OK!",
                                }).then((value) => {


                                    window.location.reload();

                                });




                            }).catch(function(error) {
                                // The document probably doesn't exist.
                                console.error("Error updating document: ", error);



                            });


                        });
                    });




                }).catch(function(error) {




                });





            }




        }



    };

    const validate = () => {

        let isError = false;
        const errors = {
            eventName:false,
            eventDescription:false,
        };
        if(eData.eventName===""){
            isError = true;
            errors.eventName = true;
        }
        if(eData.eventDescription===""){
            isError = true;
            errors.eventDescription = true;
        }



        if(isError){

            setError1(errors)
        }
        return isError;
    };

    const handleChange = (props)=>(e) => {

        if(props==="eventName"){

            setEdata({eventName:e.target.value,eventDescription:eData.eventDescription})
        }
        if(props==="eventDescription"){

            setEdata({eventName:eData.eventName,eventDescription:e.target.value})
        }

    };

    const updateEventData = (e) => {

        e.preventDefault();
        const validateErrors = validate();
        if(!validateErrors){

            const errors = {
                eventName:false,
                eventDescription:false,
            };

            setError1(errors);
            //  alert('all valid');
            var participantCollecion = db.collection("booking").doc(eventId);
            participantCollecion.update({
                b_e_name:eData.eventName,
                b_e_description:eData.eventDescription,

            }).then(function() {

                swal({
                    title: "Successfully updated",
                    text: "Successfully updated",
                    icon: "success",
                    button: "OK!",
                }).then((value) => {

                    window.location.reload();

                });
                //window.location.reload();

            }).catch(function(error) {

            });


        }

    };

    const updateEventImage = (e) => {

        e.preventDefault();

        if(eImgData.eventImageData.length<=0){


            swal("select eventImage");


        }else {

            // alert(eImgData.eventImageData.name +" "+eImgData.eventOldImage+" "+eImgData.eventImageId);
            setShowLoading(true);
            var storageRef0 = firebase.storage().ref();
            storageRef0.child('eventImages/'+eImgData.eventOldImage).delete().then(function() {


                var bannerImage  = eImgData.eventImageData;
                var bannerFileName = (+new Date()) + '-' + bannerImage.name;
                var storageRef = firebase.storage().ref();
                var uploadTask = storageRef.child('eventImages/'+bannerFileName+'').put(bannerImage);
                uploadTask.on('state_changed', function(snapshot){

                    var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                    console.log('Upload is ' + progress + '% done');
                    switch (snapshot.state) {
                        case firebase.storage.TaskState.PAUSED: // or 'paused'
                            console.log('Upload is paused');
                            break;
                        case firebase.storage.TaskState.RUNNING: // or 'running'
                            console.log('Upload is running');
                            break;
                    }
                }, function(error) {

                }, function() {

                    uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {

                        db.collection("booking").doc(eventId).collection("event_images").doc(eImgData.eventImageId).update({
                            e_image_filename: bannerFileName,
                            e_image_id: eImgData.eventImageId,
                            e_image_url: downloadURL.toString(),

                        }).then(function() {

                            setShowLoading(false);
                            swal({
                                title: "Successfully updated",
                                text: "Successfully updated",
                                icon: "success",
                                button: "OK!",
                            }).then((value) => {


                                window.location.reload();

                            });

                        });


                    });
                });





            }).catch(function(error) {




            });














        }




    };

    const deleteBlock = (props) => (e) => {

        e.preventDefault();
        db.collection("booking").doc(eventId).collection("event_blocks").doc(props).delete().then(function() {

            swal({
                title: "Successfully deleted",
                text: "Successfully deleted",
                icon: "success",
                button: "OK!",
            }).then((value) => {

                window.location.reload();

            });


        }).catch(function(error) {
            console.error("Error removing document: ", error);
        });

        // alert(props);

    };



    React.useState(()=>{




        db.collection("booking").doc(eventId).get().then((doc) => {

            setShowLoading(true);
            eventData = [];
            if(doc.exists){

                const ids = doc.id;

                const data = doc.data();
                const eId = data.b_e_id;
                const eName = data.b_e_name;
                const eDescription = data.b_e_description;
                const oId = data.o_id;
                const oName = data.o_name;
                const hallName = data.h_e_hall_name;
                const eStatus = data.b_e_status;
                const eLicenseUrl = data.b_e_licenseUrl;
                var bookingDates = "";
                const eLicenseFileName = data.b_e_licensedoc;
                scegaLicense.oldfile = eLicenseFileName;
                eData.eventName = eName;
                eData.eventDescription = eDescription;

                const contractForm = data.contract_form || "0";



                if(eStatus==="processing" || eStatus==="completed" || eStatus ==="active" || eStatus ==="confirmed"){

                    if(contractForm === "1"){

                        setTimeout(()=>{

                            setcontractBtn(true)

                        },500)

                    }



                    setTimeout(()=>{

                        setReciptBtn(true)

                    },500)



                }



                db.collection("booking").doc(eventId).collection("booking_dates").get().then(function (querySnapshot) {
                    var bCount = 0;
                    querySnapshot.forEach(function (doc) {

                        var bDate = doc.data();

                        if(bCount<2){

                            bookingDates +=" "+bDate.booked_date;
                        }

                    });
                });

                db.collection("organiser").doc(oId).get().then(function(doc) {
                    if (doc.exists) {

                        const oDatas = doc.data();

                        const oName = oDatas.o_name;
                        const oCName = oDatas.o_c_name;
                        const oMobileNumber = oDatas.o_mobilenumber;

                        setTimeout(()=>{

                            setOrganizerData({oName:oName,oCompanyName:oCName,oMobileNumber:oMobileNumber})

                        },500)


                    } else {
                        // doc.data() will be undefined in this case
                        console.log("No such document!");
                    }
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });


                setTimeout(()=>{

                    rows.push(createData("1",bookingDates,eId,eName,oName,hallName,eStatus,eLicenseUrl));
                    eventData.push(createData("1",bookingDates,eId,eName,oName,hallName,eStatus,eLicenseUrl));
                    setEventData(eventData)
                    setShowLoading(false)

                },1000);




            }else{


            }


        });

        db.collection("booking").doc(eventId).collection("event_images").get().then((querySnapshots) => {

            var imageCount = 0;
            querySnapshots.forEach((doc)=>{

                imageCount++;
                const imageData = doc.data();
                const imageId = imageData.e_image_id;
                const imageFileName = imageData.e_image_filename;
                const imageUrl = imageData.e_image_url;

                eventImages.push(createEventImages(imageCount,imageId,imageFileName,imageUrl))



            });
            setEventImages(eventImages);




        });

        db.collection("booking").doc(eventId).collection("booking_dates").get().then((querySnapshots) => {

            var dateCount = 0;

            querySnapshots.forEach((doc)=>{

                dateCount++;

                const dateData = doc.data();

                const startDate = dateData.e_startDate.toDate();
                const endDate = dateData.e_endDate.toDate();


                const newStartDate = new Date(startDate).getDate()+"/"+parseInt(new Date(startDate).getMonth()+1)+"/"+new Date(startDate).getFullYear();
                const newEndDate = new Date(endDate).getDate()+"/"+parseInt(new Date(endDate).getMonth()+1)+"/"+new Date(endDate).getFullYear();

                setTimeout(()=>{

                    setEventDates(newStartDate+" to "+ newEndDate)

                },500)



            })




        });

        

        db.collection("booking").doc(eventId).collection("layout_image").get().then((querySnapshots) => {

            var imageCount = 0;
            querySnapshots.forEach((doc)=>{

                imageCount++;
                const imageData = doc.data();
                const imageId = imageData.l_id;
                const imageFileName = imageData.l_image_filename;
                const imageUrl = imageData.l_image_url;

                eventLayoutImages.push(createEventLayoutImages(imageCount,imageId,imageFileName,imageUrl))



            });
            setEventLayoutImage(eventLayoutImages);


        });

        db.collection("booking").doc(eventId).collection("event_blocks").get().then((querySnapShots)=>{

            var blockCount = 0;
            eventBlocks = [];
            querySnapShots.forEach((doc)=>{

                blockCount++;

                const blockData = doc.data();

                const blockId = blockData.b_id;
                const blockPrice = blockData.b_label_price;
                const blockLabelName = blockData.b_lable_name;
                const participantId = blockData.b_participent_id;
                const participantName = blockData.b_participent_name || "Not Booked";
                const participantStatus = blockData.b_participient_status || "Not Booked";






                eventBlocks.push(createBlockData(blockCount,blockId,blockPrice,blockLabelName,participantId,participantName,participantStatus))



            })
            setEventBlocks(eventBlocks)


        });

        db.collection("booking").doc(eventId).collection("ad_on_service").get().then((querySnapShots)=>{

            var addonCount = 0;




            querySnapShots.forEach((doc)=>{

                addonCount++;

                const addonData = doc.data();

                const addonId = addonData.ad_s_id;
                const addonAmount = addonData.ad_s_amount;
                const addonType = addonData.ad_s_type;
                eventAddonService.push(createAddonService(addonCount,addonId,addonType,addonAmount));



            });
            setEventAddonService(eventAddonService);



        });

        db.collection("booking").doc(eventId).collection("events_all_leads").get().then((querySnapShots)=>{

            var leadCount = 0;
            eventLeads = [];
            querySnapShots.forEach((doc)=>{

                leadCount++;

                const leadData = doc.data();

                const cId = leadData.c_id;
                const cName = leadData.c_name;
                const cPhone = leadData.c_reg_mobile;
                const sId = leadData.s_id;
                const sName = leadData.s_name;

                eventLeads.push(createEventLeads(leadCount,cId,cName,cPhone,sId,sName))



            });
            setEventLeads(eventLeads);


        });






    });

    const downloadPdfArabic = () =>  {

        const doc = new jsPDF();


        doc.addFont(amirifont, "Amiri", "normal");

        doc.setFont("Amiri");
        doc.setFontSize(18);
        doc.text(5,28,organizerData.oCompanyName);
        doc.text(5,36,organizerData.oName);
        doc.text(5,44,organizerData.oMobileNumber);
       // doc.text(5,54,"الموضوع:  حجز مبدئي");
        //doc.rect(5, 10, 90, 40)


        doc.setFont("Amiri");
        doc.setFontSize(18);
        doc.text(145,28,"الرقم:  "+organizerData.oMobileNumber);
        doc.text(182,36,"التاريخ");
        doc.text(180,44,"الموافق");
        doc.text(150,54,"الموضوع:  حجز مبدئي");
        //doc.rect(110, 10, 90, 40)//

        doc.addImage(alroshanLogo, "png", 185, 10, 15, 15);


        doc.text(180,70,"السادة/  م");
        doc.text(38,80,eventDates+"السلام عليكم ورحمة الله وبركاته ... وبعد:ه ");
        doc.text(48,90,"إشارة إلى طلبك لحجز معرض روشان ومركز المؤتمرات بحائل اعتباراً من");
        doc.text(138,100,"يقام معرضاً للسلع الاستهلاكية");
        doc.text(28,110,"نعلمك أنه تم حجزه لك خلال هذه الفترة كحجز أولي حتى تزودنا بتصريح المعرض");
        doc.text(170,120,"الله ولي التوفيق ");

        doc.text(80,150," المدير العام");
        doc.text(70,160,"مشاري صالح المشاري");


        doc.save(Math.floor(Math.random() * 1000000000)+"booking-recipt.pdf");

    };

    const downloadRentContractPdfArabic = () =>  {

        const lMargin=5; //left margin in mm
        const rMargin=5; //right margin in mm
        const pdfInMM=250;



        const doc = new jsPDF();
        let width = doc.internal.pageSize.getWidth();

        doc.addFont(amirifont, "Amiri", "normal");


        doc.addImage(alroshanLogo, "png", 185, 10, 15, 15);


        doc.setFont("Amiri");
        doc.setFontSize(15);
        doc.text(88,20,"بسم الله الرحمن الرحيم");
        doc.setFontSize(19);
        doc.text(100,30,"عقد إيجار");
        doc.setFontSize(12);


        const paragraph0= "إنه في يوم ......................م تم بحمد الله وتوفيقه في مدينة حائل الاتفاق والتراضي على إبرام هذا العقد بين كل من:"
        const lines0 =doc.splitTextToSize(paragraph0, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin+30,60,lines0);//


        const paragraph1="1: الطرف الأول: السيد/ مشاري صالح المشاري – بطاقة أحوال رقم 1010024113 – صادرة من مدينة حائل بتاريخ 06/09/1396هـ وعنوانه: ص.ب 1647 الرمز البريدي 81441 حائل ويمثله في هذا العقد/ صالح مشاري المشاري، بصفته المدير التنفيذي ويشار إليه (المؤجر)."

        const lines1 =doc.splitTextToSize(paragraph1, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,70,lines1);


        const paragraph2="2: الطرف الثاني: مؤسسة ......................... سجل تجاري رقم ................-   ويمثلها في هذا العقد : 	..........  – بطاقة أحوال رقم ............ - بصفتها المدير التنفيذي ويشار إليه (المستأجر)."
        const lines2 =doc.splitTextToSize(paragraph2, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,90,lines2);


        doc.text(5,105,"تمهيد:")



        const paragraph3="حيث أن الطرف الأول هو المالك لمركز الروشن للمعارض والمؤتمرات والمفوض نظاماً لتأجير العقار المعد للاستغلال التجاري والكائن بشارع الملك خالد بحي صبابة بمدينة حائل"
        const lines3 =doc.splitTextToSize(paragraph3, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,115,lines3);

        const paragraph4="وحيث أن الطرف الثاني قد قبل استئجار مركز المعارض الموصوف أعلاه لاستغلاله في نشاطه التجاري لإقامة معرض إستهلاكي "+"................"+" وعليه فقد تم الاتفاق بين الطرفين وهما بأتم الأوصاف المعتبرة شرعاً ونظاماً على ما يلي: "
        const lines4 =doc.splitTextToSize(paragraph4, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,125,lines4);


        doc.text(5,140,"المادة (1) التمهيد :");


        const paragraph5=" يعتبر هذا التمهيد والملاحق المرفقة جزء لا يتجزأ من هذا العقد وتقرأ وتفهم معه"
        const lines5 =doc.splitTextToSize(paragraph5, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,150,lines5);


        doc.text(5,160,"المادة (2) موضوع العقد :");


        const paragraph6="بمقتضى أحكام هذا العقد ووفقاً لشروطه وملاحقه، يؤجر الطرف الأول للطرف الثاني مركز المعارض الموصوف أعلاه، وفقاً للقيمة الإيجارية والشروط الأخرى الواردة أدناه"
        const lines6 =doc.splitTextToSize(paragraph6, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,170,lines6);


        doc.text(5,185,"المادة (3) مدة العقد :");


        const paragraph7="مدة هذا العقد هي ....................... يوماً  (......................) تبدأ اعتباراً من ..............هـ."
        const lines7 =doc.splitTextToSize(paragraph7, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,195,lines7);


        doc.text(5,205,"المادة (4) القيمة الإيجارية: ");


        const paragraph8="وافق الطرفان على تحديد القيمة الإيجارية لمركز المعارض بقيمة ................................................. ريال سعودي لا غير على أن يكون إيجار اليوم الواحد قدره ×××××× ريال سعودي (××××××) بالإضافة إلى خمسة أيام للفك والتركيب على أن يكون إيجار اليوم الواحد للفك والتركيب مجاني وفي حالة رغبة الطرف الثاني في تمديد مدة العقد، يحسب كل يوم إضافي بنفس السعر المتفق عليه وهو ................................ ريال لكل يوم. بالإضافة لـ أربعون الف ريال سعودي ..................................... كقيمة مضافة"
        const lines8 =doc.splitTextToSize(paragraph8, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,215,lines8);


        doc.text(5,240,"المادة (5) طريقة الدفع :");


        const paragraph9= "سعودي .............. باقي القيمة الإيجارية و ............. ريال سعودي .............. القيمة المضافة- \nالدفعة الأخيرة: ............... ريال سعودي ............. قبل تاريخ 23/02/2020م شاملة .............. ريال- \n الدفعة الثانية: ............... ريال سعودي ............. قبل تاريخ 10/01/2020م شاملة ××××× ريال تأمين - \nالدفعة الأولى: ............... ريال سعودي ............... عند توقيع الع --.\nيلتزم الطرف الثاني بالدفعات الآتي"
        const lines9=doc.splitTextToSize(paragraph9, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,255,lines9);


        doc.addPage();


        doc.text(5,10,"المادة (6) حقوق والتزامات المستأجر:");

        const paragraph10= "6/1: يقر المستأجر بأن الغرض من الاستئجار هو استغلال مركز المعارض لإقامة معرض إستهلاكي بمسمى ..........\n  6/2: يلتزم المستأجر بعدم استغلال مركز المعارض لأي نشاط آخر مخالف جوهرياً للغرض المستأجر من أجله إلا بعد الحصول مسبقاً على موافقة المؤجر الخطية، كما يلتزم بعدم استخدام مركز المعارض في أي غرض أو نشاط غير مشروع أو مخالف للعقد أو للقوانين والأنظمة والتعليمات السارية في المملكة. \n  6/3: يلتزم المستأجر بتسليم مركز المعارض للمؤجر بعد انتهاء أو إنهاء هذا العقد لأي سبب وذلك بالحالة التي هي عليها عند الإخلاء بشرط أن تكون خالية من العيوب، ويتم التسليم بموجب محضر يوقع عليه كلا الطرفين. \n  6/4: يلتزم المستأجر بدفع قيمة الإيجار للمؤجر وفقاً للمادة (5) أعلاه، وإذا تأخر المستأجر في الدفع جاز للمؤجر المطالبة بمستحقاته المتبقية بكافة الطرق النظامية. \n 6/5: يوافق المستأجر على تعويض وحماية المؤجر عن المطالبات الناجمة عن استغلاله مركز المعارض والتي قد تنشأ للغير في مواجهته بسبب أي فعل أو إهمال من قبل المستأجر أو من قبل مندوبيه أو موظفيه أو عملاءهم ولا يسمح بإجراء أي تثبيت بالمسامير سواء بالأرضيات أو الجدران.. \n  6/6: يتحمل المستأجر قيمة جميع المصروفات على الخدمات كالنظافة طيلة مدة العقد.\n 6/7: يلتزم المستأجر بدفع مبلغ خمسون ألف ريال كـ النظافة والتلفيات إن وجدت عند إستلام مركز المعارض وبعد إنتهاء مدة العقد، يتم التصفية وجميع المصروفات الأخرى إن وجدت  \n 6/8: يلتزم المستأجر بتأمين عدد كافي من عمالة النظافة والحراسات الأمنية لمركز المعارض.\n 6/9: يلتزم المستأجر بمنع دخول السيارات والبضائع من البوابة الرئيسية ويسمح بدخولها من الخلف فقط.\n 6/10: يلتزم المؤجر بتسليم مركز المعارض بتاريخ 09/02/2020م في تمام الساعة الثامنة صباحاً لتركيب التجهيزات الخاصة بهم\n 6/11: يلتزم المستأجر بتسليم مركز المعارض في بتاريخ 06/03/2020م في تمام الساعة العاشرة مساءً نظيفاً كما استلمه وخالياً من التلفيات والعيوب.\n 6/12: في حالة تأخير تسليم مركز المعارض يتم إحتساب الأيام الإضافية حسب القيمة المقرة في المادة (4)."
        const lines10=doc.splitTextToSize(paragraph10, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,15,lines10);

        doc.text(5,125,"المادة (7) حقوق المؤجر:");


        const paragraph11=  "7/1: يقر المؤجر بأن مركز المعارض مستوفي كافة اشتراطات الأمن والسلامة وكافة متطلبات البرنامج الوطني للمعارض والمؤتمرات والمتعلقة بتشغيل المركز. كما أقر بأن المركز مسجل لدى البرنامج الوطني للمعارض والمؤتمرات عبر البوابة الالكترونية وأن شهادة الدفاع المدني سارية المفعول\n 7/2: في حال عدم استيفاء أيا من هذه الاشتراطات وعدم تمكن المستأجر من الحصول على الترخيص لإقامة معرض إستهلاكي بسبب ذلك، فإن المؤجر يلتزم بإرجاع كامل القيمة الإيجارية للمستاجر.\n 7/3: يلتزم المؤجر بتكاليف الكهرباء والماء فقط لا غير"
        const lines11=doc.splitTextToSize(paragraph11, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,135,lines11);


        doc.text(5,170,"المادة (8) انتهاء العقد أو إنهاءه:");

        const paragraph12= "8/1: ينتهي هذا العقد وفقاً لما ورد في المادة (3) منه.\n 8/2: إذا قصر المستأجر في دفع الإيجار في مواعيده أو لم يراع التزاماته الأخرى الواردة بالعقد أو ملاحقه، عندئذ يحق للمؤجر إنهاء العقد."
        const lines12=doc.splitTextToSize(paragraph12, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,180,lines12);

        doc.text(5,200,"المادة (9) النظام الواجب التطبيق والاختصاص:");

        const paragraph13= "9/1: يتم تطبيق أحكام هذا العقد وتفسيره وفقاً لأحكام واللوائح السارية المفعول بالمملكة العربية السعودية.\n 9/2: تحال كافة المنازعات المتعلقة بتنفيذ أحكام هذا العقد التي يتعذر حلها ودياً بين الطرفين إلى الجهات المختصة في المملكة العربية السعودية."
        const lines13=doc.splitTextToSize(paragraph13, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,210,lines13);

        doc.text(5,230,"المادة (10) اتفاق لاحق:");

        const paragraph14= "يقر الطرفان بأن أي اتفاق بينهما لاحقاً لهذا العقد، يعتبر جزء منه لا ينفصل عنه بأي حال من الأحوال، ويعتبر ملحقاً من ملاحق العقد.";
        const lines14=doc.splitTextToSize(paragraph14, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,240,lines14);


        doc.text(5,255,"المادة (11) التعديلات:");

        const paragraph15= "إذا تم إدخال أي تعديلات على هذا العقد فإنها لا تكون معتمدة إلا إذا كانت مكتوبة وموقعة من الطرفين، وفي هذه الحالة تعتبر هذه التعديلات جزء لا يتجزأ من هذا العقد."
        const lines15=doc.splitTextToSize(paragraph15, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,265,lines15);

        doc.addPage();

        doc.text(5,15,"المادة (12) نطاق العقد:");

        const paragraph16= "هذا العقد وملاحقه يتضمن كل ما اتفق عليه الطرفان وهو يلغي كل ما سبق من مفاوضات أو مناقشات أو اتفاقات بينهما."
        const lines16=doc.splitTextToSize(paragraph16, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,25,lines16);


        doc.text(5,35,"المادة (13) الإشعارات:");

        const paragraph17= "كل الإشعارات المكتوبة والمراد تسليمها ترسل على عنون الطرفين الموضحة بمقدمة هذا العقد بالبريد المسجل أو تسلم مناولة لقاء التوقيع بالاستلام من الطرف صاحب العلاقة أو الوكيل أو المفوض رسمياً عنه، وفي حالة قيام أحد الطرفين بتغيير عنوانه عليه إخطار الطرف الآخر بذلك كتابةً خلال سبعة أيام من تاريخ التغيير."
        const lines17=doc.splitTextToSize(paragraph17, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,45,lines17);

        doc.text(5,65,"المادة (14) نسخ العقد:");

        const paragraph18=  "حرر هذا العقد من نسختين أصليتين، استلم كل طرف نسخة منه للعمل بموجبها بعد التوقيع عليها وفهم مضمونها الفهم التام النافي للجهالة والغرر، وإن أي زيادة في إحدى النسختين لا وجود لها في الأخرى تعتبر لاغية ولا قيمة لها."
        const lines18=doc.splitTextToSize(paragraph18, (pdfInMM-lMargin-rMargin));

        doc.text(lMargin,75,lines18);


        doc.text(5,95,"وأذنا لمن يشهد والله خير الشاهدين ...");

        //right
        doc.setFontSize(18)
        doc.text(150,120,"الطرف الأول");

        doc.setFontSize(14)
        doc.text(170,130,"الاسم");

        doc.setFontSize(14)
        doc.text(142,140,"مشاري صالح المشاريل");

        doc.setFontSize(14)
        doc.text(148,150,"المفوض بالتوقيع: ل");


        doc.setFontSize(14)
        doc.text(142,160,"صالح مشاري المشاريل");

        doc.setFontSize(14)
        doc.text(165,170,"التوقيع: ل");

        doc.setFontSize(14)
        doc.text(150,180,"...............................");


        //left
        doc.setFontSize(18)
        doc.text(50,120,"الطرف الثاني");

        doc.setFontSize(14)
        doc.text(68,130,"الاسم");

        doc.setFontSize(14)
        doc.text(68,140,"مؤسسة");

        doc.setFontSize(14)
        doc.text(52,150,"المفوض بالتوقيع: ");

        doc.setFontSize(14)
        doc.text(50,160,".............................");

        doc.setFontSize(14)
        doc.text(68,170,"التوقيع");

        doc.setFontSize(14)
        doc.text(50,180,".............................");







        doc.save(Math.floor(Math.random() * 1000000000)+"booking-recipt.pdf");

    };


    return (<div>


            {showLoading===true ? <div className={classes.root4}>
                <CircularProgress  />
            </div>:null}


            { reciptBtn === true ? <Typography variant="span" component="span" style={{float:'right',marginRight:'10px'}}>
                { selectedLanguage==='ar' ? " إيصال الحجز":selectedLanguage==='en' ? "Booking Receipt ":null}
                <IconButton aria-label="delete" className={classes.margin} onClick={() => { downloadPdfArabic(); }}>
                    <GetAppIcon fontSize="large" />
                </IconButton >
            </Typography> : null}

            { contractBtn === true ? <Typography variant="span" component="span" style={{float:'right',marginRight:'10px'}}>
                { selectedLanguage==='ar' ? " عقد إيجار":selectedLanguage==='en' ? "Rent contract ":null}
                <IconButton aria-label="delete" className={classes.margin} onClick={() => { downloadRentContractPdfArabic(); }}>
                    <GetAppIcon fontSize="large" />
                </IconButton >
            </Typography> : null}




            {bookingStatus!== "cancelled" ?

                <Box style={{float:'left',marginTop:'50px',marginBottom:'5px'}}>
                <AddCircleOutlineIcon fontSize="small"  style={{cursor:'pointer','float':'right'}} onClick={handleOpen4()} />
                <EditIcon fontSize="small"  style={{cursor:'pointer','float':'right'}} onClick={handleOpen} />
                </Box>
                :null
            }



            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open}
                onClose={handleClose}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open}>
                    <div className={classes.paper}>
                        <form  id="security-form" noValidate autoComplete="off" onSubmit={updateEventData}>
                            <Box mt={2}>
                                <FormGroup row>
                                    <TextField
                                        required
                                        id="standard-name-input"
                                        label={ selectedLanguage==='ar' ? "اسم الحدث":selectedLanguage==='en' ? "Event Name":null}
                                        type="text"
                                        name="name"
                                        variant="outlined"
                                        autoComplete="current-password"
                                        onChange={handleChange('eventName')}
                                        value={eData.eventName}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        error={error1.eventName}
                                    />
                                    <Box ml={2}>
                                        <TextField
                                            required
                                            id="standard-name-input"
                                            label={ selectedLanguage==='ar' ? "وصف الحدث":selectedLanguage==='en' ? "Event Description":null}
                                            type="text"
                                            name="name"
                                            variant="outlined"
                                            autoComplete="current-password"
                                            onChange={handleChange('eventDescription')}
                                            value={eData.eventDescription}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            error={error1.eventDescription}
                                        />
                                    </Box>
                                </FormGroup>
                            </Box>
                            <FormGroup row>
                                <Box mt={2}>
                                    <Button variant="contained" type="submit">
                                        { selectedLanguage==='ar' ? "تحديث":selectedLanguage==='en' ? "Update":null}
                                    </Button>
                                </Box>
                            </FormGroup>
                        </form>
                    </div>
                </Fade>
            </Modal>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open1}
                onClose={handleClose1}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open1}>
                    <div className={classes.paper}>
                        <form  id="security-form" noValidate autoComplete="off" onSubmit={updateEventImage}>
                            <Box mt={2}>
                                <FormGroup row>
                                    <TextField
                                        error={error1.organiserFiles}
                                        id="doc-file"
                                        label={ selectedLanguage==='ar' ? "صورة الحدث":selectedLanguage==='en' ? "Event Image":null}
                                        variant="outlined"
                                        type="file"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={handleEventImageChange('eventImage')}
                                    />
                                </FormGroup>
                            </Box>
                            <FormGroup row>
                                <Box mt={2}>
                                    <Button variant="contained" type="submit">

                                        { selectedLanguage==='ar' ? "تحديث":selectedLanguage==='en' ? "Update":null}
                                    </Button>
                                </Box>
                            </FormGroup>
                        </form>
                    </div>
                </Fade>
            </Modal>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open2}
                onClose={handleClose2}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open2}>
                    <div className={classes.paper}>
                        <form  id="security-form" noValidate autoComplete="off" onSubmit={addLayoutImage}>
                            <Box mt={2}>
                                <FormGroup row>
                                    <TextField
                                        error={error1.organiserFiles}
                                        id="doc-file"
                                        label={ selectedLanguage==='ar' ? "صورة التخطيط":selectedLanguage==='en' ? "Layout Image":null}
                                        variant="outlined"
                                        type="file"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={handleChangeLayoutImage('eventLayoutImage')}
                                    />
                                </FormGroup>
                            </Box>
                            <FormGroup row>
                                <Box mt={2}>
                                    <Button variant="contained" type="submit">

                                        { selectedLanguage==='ar' ? "أضف":selectedLanguage==='en' ? "Add":null}
                                    </Button>

                                </Box>
                                <Box mt={2} ml={1}>
                                    <Button variant="contained" onClick={handleClose2()}>

                                        { selectedLanguage==='ar' ? "قريب":selectedLanguage==='en' ? "Close":null}
                                    </Button>
                                </Box>
                            </FormGroup>
                        </form>
                    </div>
                </Fade>
            </Modal>
            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open3}
                onClose={handleClose3}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open3}>
                    <div className={classes.paper}>
                        <form  id="security-form" noValidate autoComplete="off" onSubmit={addEventBlocks}>
                            <Box mt={2}>
                                <FormGroup row>
                                    <TextField
                                        required
                                        id="standard-name-input"
                                        label={ selectedLanguage==='ar' ? "تسمية كشك":selectedLanguage==='en' ? "Booth Label":null}
                                        type="text"
                                        name="name"
                                        variant="outlined"
                                        autoComplete="current-password"
                                        onChange={handleBlockDataChange('eBlockLabel')}
                                        value={eBlockData.eBlockLabel}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        error={error1.eBlockLabel}
                                    />
                                    <Box ml={1}>
                                    <TextField
                                        required
                                        id="standard-name-input"
                                        label={ selectedLanguage==='ar' ? "سعر كشك":selectedLanguage==='en' ? "Booth Price":null}
                                        type="number"
                                        name="name"
                                        variant="outlined"
                                        autoComplete="current-password"
                                        onChange={handleBlockDataChange('eBlockPrice')}
                                        value={eBlockData.eBlockPrice}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        error={error1.eBlockPrice}
                                    />
                                    </Box>
                                </FormGroup>
                            </Box>
                            <FormGroup row>
                                <Box mt={2}>
                                    <Button variant="contained" type="submit">

                                        { selectedLanguage==='ar' ? "أضف":selectedLanguage==='en' ? "Add":null}
                                    </Button>

                                </Box>
                                <Box mt={2} ml={1}>
                                    <Button variant="contained" onClick={handleClose3()}>

                                        { selectedLanguage==='ar' ? "قريب":selectedLanguage==='en' ? "Close":null}
                                    </Button>
                                </Box>
                            </FormGroup>
                        </form>
                    </div>
                </Fade>
            </Modal>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open4}
                onClose={handleClose4}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open4}>
                    <div className={classes.paper}>
                        <form  id="security-form" noValidate autoComplete="off" onSubmit={addScegaLicense}>
                            <Box mt={2}>
                                <FormGroup row>
                                    <TextField
                                        error={error1.organiserFiles}
                                        id="doc-file"
                                        label={ selectedLanguage==='ar' ? "ترخيص SCEGA":selectedLanguage==='en' ? "SCEGA License":null}
                                        variant="outlined"
                                        type="file"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={handleScegaLicense('scegaLicenseFile')}
                                    />
                                </FormGroup>
                            </Box>
                            <FormGroup row>
                                <Box mt={2}>
                                    <Button variant="contained" type="submit">
                                        { selectedLanguage==='ar' ? "أضف":selectedLanguage==='en' ? "Add":null}
                                    </Button>

                                </Box>
                                <Box mt={2} ml={1}>
                                    <Button variant="contained" onClick={handleClose4()}>
                                        { selectedLanguage==='ar' ? "قريب":selectedLanguage==='en' ? "Close":null}
                                    </Button>
                                </Box>
                            </FormGroup>
                        </form>
                    </div>
                </Fade>
            </Modal>

            <Modal
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                className={classes.modal}
                open={open5}
                onClose={handleClose5}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={open5}>
                    <div className={classes.paper}>
                        <form  id="security-form" noValidate autoComplete="off" onSubmit={addBulkBlock}>

                            <CloseIcon style={{float:'right',cursor:'pointer'}}  onClick={handleClose5()}/>
                            <Typography variant="h6" component="h2">

                                { selectedLanguage==='ar' ? "تحميل Booth CSV File":selectedLanguage==='en' ? "Upload Booth CSV File":null}
                            </Typography>
                            {/* <Button variant="contained" style={{float:'right'}} onClick={handleClose5()}>
                             Close
                             </Button>*/}

                            <Box mt={2}>
                                <FormGroup row>
                                    <TextField
                                        accept="text/csv"
                                        id="doc-file"
                                        label="CSV File"
                                        variant="outlined"
                                        type="file"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        onChange={handleChangeBulkBlock('eventBulkBlock')}
                                    />
                                </FormGroup>
                            </Box>
                            <FormGroup row>
                                <Box mt={2}>
                                    <Button variant="outlined" color="primary" type="submit" style={{width:'340px'}}>

                                        { selectedLanguage==='ar' ? "رفع":selectedLanguage==='en' ? "Upload":null}
                                    </Button>



                                </Box>



                            </FormGroup>
                            <FormGroup row>
                                <Box mt={2}>
                                    <a href="https://firebasestorage.googleapis.com/v0/b/alroshan-1775a.appspot.com/o/test%2Fboothtemplate.csv?alt=media&token=60179988-26e4-4b31-b2e5-bf10754b9d10"  download>Download CSV Template</a>

                                </Box>
                            </FormGroup>
                        </form>
                    </div>
                </Fade>
            </Modal>





        <TableContainer component={Paper}>



            <Table className={classes.table} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell align="left">
                            { selectedLanguage==='ar' ? "رقم":selectedLanguage==='en' ? "SI.No":null}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            { selectedLanguage==='ar' ? "تاريخ الحدث":selectedLanguage==='en' ? "Event Date":null}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            { selectedLanguage==='ar' ? "اسم الحدث":selectedLanguage==='en' ? "Event Name":null}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            { selectedLanguage==='ar' ? "منظم":selectedLanguage==='en' ? "Organizer":null}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            { selectedLanguage==='ar' ? "صالة":selectedLanguage==='en' ? "Hall":null}
                        </StyledTableCell>
                        <StyledTableCell align="left">

                            { selectedLanguage==='ar' ? "ترخيص SCEGA":selectedLanguage==='en' ? "SCEGA License":null}
                        </StyledTableCell>
                        <StyledTableCell align="left">
                            { selectedLanguage==='ar' ? "الحالة":selectedLanguage==='en' ? "Status":null}
                        </StyledTableCell>


                    </TableRow>
                </TableHead>
                <TableBody>
                    {eventData.map((row) => (
                        <StyledTableRow key={row.eId} component={Link} className={classes.link} to={'/eventDetails/'+row.eId}>
                            <StyledTableCell align="left">{row.eCount}</StyledTableCell>
                            <StyledTableCell align="left">{row.eDate}</StyledTableCell>
                            <StyledTableCell align="left">{row.eName}</StyledTableCell>
                            <StyledTableCell align="left">{row.oName}</StyledTableCell>
                            <StyledTableCell align="left">{row.hallName}</StyledTableCell>
                            <StyledTableCell align="left">{row.eLicenseUrl==="" ? "Not Uploaded": row.eLicenseUrl !=="" ?

                                <a href={row.eLicenseUrl} target="_blank" style={{ textDecoration:'none'}}><Button onClick={()=> window.open(row.eLicenseUrl, "_blank")} variant="contained">{ selectedLanguage==='ar' ? "رأي":selectedLanguage==='en' ? "View":null}</Button></a>


                                :null}</StyledTableCell>
                            <StyledTableCell align="left">{row.eStatus}</StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
            <Box mt={2}>
                <Typography color="textSecondary">

                    { selectedLanguage==='ar' ? "كتل الحدث":selectedLanguage==='en' ? "Event Blocks":null}
                </Typography>

                {bookingStatus!== "cancelled" ?

                    <Box>
                        <Button fontSize="small"  style={{cursor:'pointer','float':'right'}} onClick={handleOpen5()}>

                            { selectedLanguage==='ar' ? "حجم":selectedLanguage==='en' ? " Bulk":null}
                        </Button>
                        <AddCircleOutlineIcon fontSize="small"  style={{cursor:'pointer','float':'right',marginTop:'5px'}} onClick={handleOpen3()} />
                    </Box>

                    :null
                }


                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "رقم":selectedLanguage==='en' ? "SI.No":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "تسمية كتلة":selectedLanguage==='en' ? "Booth Label":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "سعر كتلة التسمية":selectedLanguage==='en' ? "Booth Label Price":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "اسم المشارك":selectedLanguage==='en' ? "Participant":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "الحالة":selectedLanguage==='en' ? "Status":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">

                                    { selectedLanguage==='ar' ? "عمل":selectedLanguage==='en' ? "Action":null}
                                </StyledTableCell>
                                {bookingStatus!== "cancelled" ?

                                    <Box>

                                    </Box>:null

                                }



                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {eventBlocks.map((row) => (
                                <StyledTableRow key={row.blockId} component={Link} className={classes.link} to={'/eventParticipantLeads/'+eventId+'/'+row.participantId}>
                                    <StyledTableCell align="left">{row.blockCount}</StyledTableCell>
                                    <StyledTableCell align="left">{row.blockLabelName}</StyledTableCell>
                                    <StyledTableCell align="left">{row.blockPrice}</StyledTableCell>
                                    <StyledTableCell align="left">{row.participantName}</StyledTableCell>
                                    <StyledTableCell align="left">{row.participantStatus}</StyledTableCell>

                                    {bookingStatus!== "cancelled" ? <Box>

                                        {row.participantId==="" ? <StyledTableCell align="left"><DeleteIcon style={{fontSize:'14px'}} fontSize={"small"} onClick={deleteBlock(row.blockId)} /></StyledTableCell>:null}
                                        {row.participantId !=="" ? <StyledTableCell align="left"></StyledTableCell>:null}

                                    </Box>:null }

                                    {bookingStatus === "cancelled" ? <StyledTableCell align="left"></StyledTableCell>:null}



                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box mt={2}>
                <Typography color="textSecondary">

                    { selectedLanguage==='ar' ? "خدمة الملحق":selectedLanguage==='en' ? "Addon Service":null}
                </Typography>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">

                                    { selectedLanguage==='ar' ? "رقم":selectedLanguage==='en' ? "SI.No":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">

                                    { selectedLanguage==='ar' ? "نوع":selectedLanguage==='en' ? "Type":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">

                                    { selectedLanguage==='ar' ? "السعر":selectedLanguage==='en' ? "Price":null}
                                </StyledTableCell>



                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {eventAddonService.map((row) => (

                                <StyledTableRow key={row.sId}>
                                    <StyledTableCell align="left">{row.count}</StyledTableCell>
                                    <StyledTableCell align="left">{row.sType}</StyledTableCell>
                                    <StyledTableCell align="left">{row.sPrice}</StyledTableCell>

                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box mt={2}>
                <Typography color="textSecondary">
                    { selectedLanguage==='ar' ? "صورة الحدث":selectedLanguage==='en' ? "Event Image":null}
                </Typography>
                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">

                                    { selectedLanguage==='ar' ? "رقم":selectedLanguage==='en' ? "SI.No":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "صورة الحدث":selectedLanguage==='en' ? "Event Image":null}
                                </StyledTableCell>
                                <StyledTableCell>

                                    { selectedLanguage==='ar' ? "عمل":selectedLanguage==='en' ? "Action":null}
                                </StyledTableCell>


                                {bookingStatus === "cancelled" ? <StyledTableCell align="left"></StyledTableCell>:null}



                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {eventImages.map((row) =>(

                                <StyledTableRow key={row.imageId}>
                                    <StyledTableCell align="left">{row.imageCount}</StyledTableCell>
                                    <StyledTableCell align="left">
                                        <Avatar variant="square"   src={row.imageUrl} className={classes.white} style={{width:'200px',height:'98px',backgroundColor:'#ffffff'}} />
                                    </StyledTableCell>

                                    {bookingStatus!== "cancelled" ? <Box>

                                        <StyledTableCell align="left">
                                            <EditIcon fontSize="small"  style={{cursor:'pointer','float':'left'}} onClick={handleOpen1(row.imageId+"|"+row.imageName)} />
                                        </StyledTableCell>

                                    </Box>:null}

                                    {bookingStatus === "cancelled" ? <StyledTableCell align="left"></StyledTableCell>:null}




                                </StyledTableRow>

                            ))
                            }

                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
            <Box mt={2}>
                <Typography color="textSecondary">

                    { selectedLanguage==='ar' ? "تخطيط الحدث":selectedLanguage==='en' ? "Event Layout":null}
                </Typography>

                {bookingStatus!== "cancelled" ? <Box>

                    <AddCircleOutlineIcon fontSize="small"  style={{cursor:'pointer','float':'right'}} onClick={handleOpen2()} />

                </Box>:null}



                <TableContainer component={Paper}>
                    <Table className={classes.table} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "رقم":selectedLanguage==='en' ? "SI.No":null}
                                </StyledTableCell>
                                <StyledTableCell align="left">
                                    { selectedLanguage==='ar' ? "صورة التخطيط":selectedLanguage==='en' ? "Layout Image":null}
                                </StyledTableCell>
                                <StyledTableCell>
                                    { selectedLanguage==='ar' ? "عمل":selectedLanguage==='en' ? "Action":null}
                                </StyledTableCell>
                                {bookingStatus!== "cancelled" ? <Box>

                                </Box>:null}



                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {eventLayoutImages.map((row) =>(

                                <StyledTableRow key={row.imageId}>
                                    <StyledTableCell align="left">{row.imageCount}</StyledTableCell>
                                    <StyledTableCell align="left">
                                        <Avatar variant="square"   src={row.imageUrl} className={classes.white} style={{width:'200px',height:'98px',backgroundColor:'#ffffff'}} />
                                    </StyledTableCell>

                                    {bookingStatus!== "cancelled" ? <Box>

                                        <StyledTableCell align="left">
                                            <DeleteIcon fontSize="small"  style={{cursor:'pointer','float':'left'}} onClick={deleteLayoutImage(row.imageId+"|"+row.imageName)} />
                                        </StyledTableCell>

                                    </Box>:null}

                                    {bookingStatus === "cancelled" ? <StyledTableCell align="left"></StyledTableCell>:null}


                                </StyledTableRow>

                            ))
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        <Box mt={2}>

            <Typography color="textSecondary">

                { selectedLanguage==='ar' ? "حدث جميع العملاء المحتملين":selectedLanguage==='en' ? "Event All Leads":null}
            </Typography>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            <StyledTableCell align="left">
                                { selectedLanguage==='ar' ? "رقم":selectedLanguage==='en' ? "SI.No":null}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                { selectedLanguage==='ar' ? "المستعمل":selectedLanguage==='en' ? "User":null}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                { selectedLanguage==='ar' ? "رقم الجوال":selectedLanguage==='en' ? "Phone Number":null}
                            </StyledTableCell>
                            <StyledTableCell align="left">
                                { selectedLanguage==='ar' ? "اسم الأمان":selectedLanguage==='en' ? "Security Name":null}
                            </StyledTableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {eventLeads.map((row) => (
                            <StyledTableRow key={row.cId}>
                                <StyledTableCell align="left">{row.leadCount}</StyledTableCell>
                                <StyledTableCell align="left">{row.cName}</StyledTableCell>
                                <StyledTableCell align="left">{row.cPhone}</StyledTableCell>
                                <StyledTableCell align="left">{row.sName}</StyledTableCell>
                            </StyledTableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
        </div>
    );
}
